import React, { Component } from 'react';
import { Route, Switch, RouteComponentProps, withRouter  } from 'react-router-dom';
import Layout from './hoc/Layout/Layout';
import Content from './containers/Content/Content';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Video from './components/Video/Video';
import About from './components/About/About';
import './App.css';

export interface AppProps extends RouteComponentProps<any> {}
export interface AppState {}

// https://web.archive.org/web/20200109175758/http://quahogcorner.com/

class App extends React.Component<AppProps, AppState> {

    render () {
     return (
       <div>
        <div className="background"></div>
         <Layout>
            <Header />
            <Switch>
                <Route path="/video" component={Video} />
                <Route path="/about" component={About} />
                <Route path="/" exact component={Content} />
            </Switch>
            <Footer />
         </Layout>
       </div>
     );
   }
}

export default withRouter(App); //withRouter<AppProps>(App);
